enum CaseStatus {
	UNSCHEDULED = 'UNSCHEDULED',
	SCHEDULED = 'SCHEDULED',
	PENDING_CANCELLED = 'PENDING_CANCELLED',
	CANCELLED = 'CANCELLED',
}

export default CaseStatus;
